"use client";

import { cn } from "@rosette/ts/src/util/cn.js";
import { PopupButton } from "@/components/generic/popup/PopupButton.js";
import React, { useEffect, useState } from "react";
import { ShareIcon } from "@rosette/web_components/src/icon/ShareIcon.js";
import { LinkIcon } from "@rosette/web_components/src/icon/LinkIcon.js";
import { useCopy } from "@rosette/web_utils/src/useCopy.js";
import CheckIcon from "@rosette/web_components/src/icon/CheckIcon.js";


interface ShareButtonProps {
    className?: string;
}


export function ShareButton({
    className = "text-xl",
}: ShareButtonProps) {

    const [url, setURL] = useState<string | null>(null);
    const { copyText, doCopy, copyState, setCopyState } = useCopy(
        url, "Copy Link", "Copied Link",
    );

    useEffect(() => {
        setURL(new URL(window.location.pathname, window.location.href).href);
    }, [setURL]);

    return (
        <PopupButton
            buttonClassName={cn("text-xl text-body hover:text-strong", className ?? null)}
            contentClassName="p-0 rounded-2xl overflow-hidden min-w-[260px]"
            darkMode={true}
            minPopupWidthPx={240}
            buttonContent={(
                <>
                    <ShareIcon className="inline align-baseline h-[0.8em] mr-[0.4em] fill-current" />
                    <span>Share</span>
                </>
            )}
            onClose={() => {
                setCopyState("copy");
            }}>

            <button
                className={cn(
                    "w-full py-4 pr-6 pl-4 text-xl font-bold text-left bg-surface hover:bg-surface-sunken cursor-pointer",
                    "[&_svg]:inline-block [&_svg]:w-full [&_svg]:max-w-[1.5em] [&_svg]:max-h-[1.5em]",
                    "[&_svg]:mr-2 [&_svg]:align-middle [&_svg]:fill-current [&_span]:align-middle",
                    copyState === "copied" ? "text-accent-soft" : "text-strong",
                )}
                onClick={doCopy}>
                <LinkIcon />
                <span>
                    {copyText}
                </span>
                {copyState === "copied" && (
                    <CheckIcon className="ml-2" />
                )}
            </button>
        </PopupButton>
    );
}
